import type { Command } from "@/lib/commands/types";

// Open-from-context commands navigate the dispatcher from one
// entity to another it's adjacent to (load → driver, driver →
// active load, customer → orders). Pure navigation, no mutation.
//
// The hrefs are functions of CommandContext so they resolve the
// currently selected entity at invocation time, not at registration.
export const commandsContext: Command[] = [
  {
    id: "load.open_customer",
    label: "Open customer for this load",
    group: "load",
    scope: "load_detail",
    permission: "org:customers:read",
    handler: {
      kind: "navigate",
      href: (ctx) => `/customers?from_load=${ctx.loadId}`,
    },
    keywords: ["account", "go to customer"],
  },
  {
    id: "load.open_driver",
    label: "Open assigned driver",
    group: "load",
    scope: "load_detail",
    permission: "org:drivers:read",
    handler: {
      kind: "navigate",
      href: (ctx) => `/fleet/drivers?from_load=${ctx.loadId}`,
    },
    keywords: ["driver", "open driver"],
  },
  {
    id: "driver.open_active_load",
    label: "Open driver's active load",
    group: "driver",
    scope: "driver_detail",
    permission: "org:loads:read",
    handler: {
      kind: "navigate",
      href: (ctx) => `/loads?driver_id=${ctx.driverId}&status=in_transit`,
    },
    keywords: ["current trip"],
  },
  {
    id: "customer.open_orders",
    label: "Open this customer's orders",
    group: "customer",
    scope: "customer_detail",
    permission: "org:orders:read",
    handler: {
      kind: "navigate",
      href: (ctx) => `/orders?customer_id=${ctx.customerId}`,
    },
    keywords: ["orders", "history"],
  },
];
